import { useApiClient } from '~/api-client';
import { DexDevicesResource } from '@mark43/dex-api';
import { useQuery } from '@tanstack/react-query';

export function useActingUserHasDexDeviceOverride(
    { bypassCheck }: { bypassCheck: boolean } = { bypassCheck: false }
) {
    const apiClient = useApiClient();
    const query = useQuery(
        ['user-has-dex-device-override'],
        () => {
            if (bypassCheck) {
                return Promise.resolve(false);
            }
            return apiClient
                .request<DexDevicesResource.CheckActingUserHasOverride>({
                    service: 'DEX',
                    method: 'GET',
                    url: 'dex_devices/override/exists',
                })
                .then((response) => response.data.data);
        },
        {
            cacheTime: Infinity,
            staleTime: Infinity,
            refetchOnMount: false,
        }
    );
    return {
        hasDexDeviceOverride: query.data,
        isLoading: query.isLoading,
    };
}
